import { ReverseRowComponent } from "./styles";
import { ReverseRowProps } from "./types";

export const ReverseRow = (props: ReverseRowProps) => {
	return <ReverseRowComponent>{props.children}</ReverseRowComponent>;
};
